import { useEffect, useState } from "react";
import usePWAInstall from "../hooks/usePWAInstall";
import { useLocation } from "react-router-dom";

export default function InstallAppPopup() {
  const { isInstallable, installApp } = usePWAInstall();
  const location = useLocation();

  const [isStandalone, setIsStandalone] = useState(false);
  const [visible, setVisible] = useState(false);

  /* ================= CHECK STANDALONE ================= */
  useEffect(() => {
    const standalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;

    setIsStandalone(standalone);
  }, []);

  /* ================= SHOW + AUTO HIDE ================= */
  useEffect(() => {
    if (location.pathname !== "/login" && !isStandalone && isInstallable) {
      setVisible(true);

      const timer = setTimeout(() => {
        setVisible(false);
      }, 8000); // ⏱ auto-hide after 8 seconds

      return () => clearTimeout(timer);
    }
  }, [location.pathname, isStandalone, isInstallable]);

  /* ================= GUARDS ================= */
  if (!visible) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-sm animate-slide-up">
      <div className="bg-white shadow-xl rounded-xl p-4 border relative">
        {/* CLOSE BUTTON */}
        <button
          onClick={() => setVisible(false)}
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
          aria-label="Close"
        >
          ✕
        </button>

        <div className="flex items-start gap-3">
          <img
            src="/icons/clientdock-icon-192x192.png"
            alt="ClientDock"
            className="w-12 h-12 rounded-lg"
          />

          <div className="flex-1">
            <h3 className="font-semibold text-lg">Install ClientDock</h3>
            <p className="text-sm text-gray-600">
              Install ClientDock for faster access and a real app experience.
            </p>
          </div>
        </div>

        <div className="flex justify-end gap-2 mt-4">
          <button
            onClick={installApp}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
          >
            Install
          </button>
        </div>
      </div>
    </div>
  );
}
